import {history} from '../../quote-tool/globals/config';
import {generateSummary} from '../modules/summary';
import {prepareConfirmationData} from '../../quote-tool/modules/confirmation';
import {garageInfoModal} from '../modules/vehicleSelector';
import {getCalendarFromWacs} from '../../quote-tool/modules/dateSelector';
import {replacementData} from '../../quote-tool/modules/replacements';
import apAnalytics from './apAnalytics';

const $ = jQuery;
const $appointmentTool = $('#appointment-tool');

/**
 * We have these steps for now:
 * 1. garage-locator
 * 2. date-picker
 * 3. vehicle-select
 * 4. service-selector
 * 5. replacement
 * 6. user_info
 * 7. summary
 * 8. thank-you
 */

/**
 * Switch step
 *
 * @param stepName - name of step to switch to
 * @param fromReturn - if true, don't push to history
 */
export function apSwitchStep(stepName, fromReturn = false) {
	const $returnBtn = $('.js-ap-return');

	if (!fromReturn) {
		history.push(stepName);
	}

	// Normalize the step name by removing extra spaces and replacing them with hyphens
	const normalizedStepName = stepName.trim().replace(/\s+/g, '-').toLowerCase();

	// Remove any existing `step-` class and add the new one
	$appointmentTool.removeClass(function (index, className) {
		return (className.match(/\bstep-\S+/g) || []).join(' ');
	});
	$appointmentTool.addClass(`step-${normalizedStepName}`);

	switch (stepName) {
		case 'date-picker':
			getCalendarFromWacs();
			garageInfoModal('vehicle-select-contact-modal');
			$returnBtn.show();
			break;

		case 'summary':
			apAnalytics('validation--start');
			generateSummary();
			break;

		case 'replacement':
			if (replacementData.status === 'inactive') {
				stepName = 'user_info';
				apAnalytics('personal-info--start');
			} else {
				apAnalytics('choose-replacement--start');
			}
			break;

		case 'thank-you':
			prepareConfirmationData();
			$returnBtn.hide();
			break;
	}

	$appointmentTool.find('section.active').removeClass('active');
	$appointmentTool.find(`section[data-step-name="${stepName}"]`).addClass('active');

	$([document.documentElement, document.body]).animate(
		{
			scrollTop: $appointmentTool.offset().top,
		},
		0
	);

	navigation();
}


/**
 * Return to previous step
 */
export function apReturnBtn() {
    $appointmentTool.on('click', '.js-ap-return', function () {
        if (history.length > 1) {
            history.pop();
        }

        if (history.length <= 1) {
            $('.js-ap-return').hide();
        }

        apSwitchStep(history[history.length - 1], true);
    });
}

/**
 * Navigation
 */
function navigation() {
    const stepName = $('.c-qt-content > section.active').data('step-name');
    const $progressLine = $('.js-qt-progress-line');
    const steps = [
        $('.js-qt-navigation-first-step'),
        $('.js-qt-navigation-second-step'),
        $('.js-qt-navigation-third-step'),
        $('.js-qt-navigation-fourth-step'),
    ];

    if (stepName) {
        // Reset all classes
        $progressLine.removeClass('first second third fourth');
        steps.forEach(step => step.removeClass('active current'));

        if (stepName === 'garage-locator' || stepName === 'date-picker') {
            // First step
            $progressLine.addClass('first');
            steps[0].addClass('active current');
        } else if (stepName === 'vehicle-select') {
            // Second step
            $progressLine.addClass('second');
            steps[0].addClass('active');
            steps[1].addClass('active current');
        } else if (stepName === 'service-selector') {
            // Third step
            $progressLine.addClass('third');
            steps[0].addClass('active');
            steps[1].addClass('active');
            steps[2].addClass('active current');
        } else {
            // Fourth step
            $progressLine.addClass('fourth');
            steps[0].addClass('active');
            steps[1].addClass('active');
            steps[2].addClass('active');
            steps[3].addClass('active current');
        }
    }
}
